import styled from '@emotion/styled';

const SUPPORT_BASE_URL = 'https://support.moderndropship.com/article';

export type SupportLinkProps = Partial<React.ComponentPropsWithoutRef<'a'>> &
  ({ article: string; href?: never } | { href: string; article?: never });

const StyledLink = styled.a`
  color: ${({ theme }) => theme.color.bodyTextLinks};

  &:hover {
    color: ${({ theme }) => theme.color.bodyTextLinksHover};
    cursor: pointer;
  }
`;

/**
 * Link to support documentation. Use either:
 * - `article`: slug for the legacy HelpDocs URL (support.moderndropship.com/article/{article})
 * - `href`: full URL for the new knowledge base (e.g. moderndropship.frontkb.com) or any override
 */
const SupportLink = ({ article, href: hrefProp, ...linkProps }: SupportLinkProps) => {
  const href = hrefProp ?? (article ? `${SUPPORT_BASE_URL}/${article}` : undefined);

  return <StyledLink {...linkProps} as="a" href={href} target="_blank" rel="noopener noreferrer" />;
};

export default SupportLink;
